import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'

import { Button, Stack, Typography } from '@mui/material'

import PageContainer from '@/components/ui/containers/PageContainer'

import GroupsTable from './containers/GroupsTable'

export default function GroupsPage() {
  const { t } = useTranslation()

  return (
    <PageContainer>
      <Stack spacing={4}>
        <Stack direction="row" alignItems="center" justifyContent="space-between">
          <Typography variant="h2">{t('page.admin.groups.title')}</Typography>
          <Stack direction="row" alignItems="center" justifyContent="space-between" gap="10px">
            <Button component={Link} disableElevation to="/admin/groups/create" variant="contained" id="add-staff-button">
              {t('common:button.create.label')}
            </Button>
          </Stack>
        </Stack>
        <GroupsTable />
      </Stack>
    </PageContainer>
  )
}
